

const findDuplicates = (CustomerReferenceNumber, grid) => {
    const arrayForSort = [...grid]
    let sorted_grid = arrayForSort.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => ({ index, CustomerReferenceNumber: x.CustomerReferenceNumber })).sort(function (a, b) {
        return ('' + a.CustomerReferenceNumber).localeCompare(b.CustomerReferenceNumber);
    });
    let results = [];
    for (let i = 0; i < sorted_grid.length - 1; i++) {
        if (sorted_grid[i + 1].CustomerReferenceNumber == sorted_grid[i].CustomerReferenceNumber) {
            results.push(sorted_grid[i]);
        }
    }
    return results.findIndex(d => d.CustomerReferenceNumber.trim().toUpperCase() == CustomerReferenceNumber.trim().toUpperCase()) !== -1;
}


export const calculateErrors = (grid, userInfo, ct, rt) => {
    let errorsOccured = [];

    grid.map((element, index) => {
        Object.keys(element).map(key => {
            let gridObj = {
                'ShipperAdvice': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Shipper Advice is Required.",
                            fieldName: "Shipper Advice"
                        })
                    } else {
                        if (ct.filter(y => y.toUpperCase() == (element[key] && element[key].toUpperCase())).length == 0) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Invalid Shipper Advice, Select from dropdown.",
                                fieldName: "Shipper Advice"
                            })
                        }
                    }
                },
                'ActionRequired': () => {
                    if (element['advice'] == 3 && (!element[key] || element[key] === "")) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Re Attempt reason is Required.",
                            fieldName: "Re attempt reason"
                        })
                    } else {
                        if (element['advice'] == 3 && rt.filter(y => y.toUpperCase() == (element[key] && element[key].toUpperCase())).length == 0) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Invalid Re Attempt reason, Select from dropdown.",
                                fieldName: "Re Attempt reason"
                            })
                        }
                    }
                },
                'newConsigneePhone': () => {
                    if (element['reattemptReason'] == 2 && (!element[key] || element[key] === "")) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Consignee Phone No is Required.",
                            fieldName: "Consignee Phone No"
                        })
                    } else if (element['reattemptReason'] == 2 && element[key] && element[key].length > 49) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Maximum length is 50 characters.",
                            fieldName: "Consignee Phone No"
                        })
                    }
                },
                'newConsigneeAddress': () => {
                    if (element['reattemptReason'] == 2 && (!element[key] || element[key] === "")) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Consignee Address is Required.",
                            fieldName: "Consignee Address"
                        })
                    } else {
                        if (element['reattemptReason'] == 2 && element[key].length > 255) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Maximum length is 255 characters.",
                                fieldName: "Consignee Address"
                            })
                        }
                    }
                },
                'default': () => (console.log())
            };
            let executeValidation = gridObj[key] || gridObj['default'];
            return executeValidation();
        })
    })

    return errorsOccured;
}